<template>
    <div class="row step direction">
        <div class="col-3 col-lg-4 overflow-hidden position-relative">
            <div class="time d-flex align-items-center justify-content-end">
                <div class="circle-icon ml-2">
                    <svg-icon :aria-labelledby="icon" :name="icon" height="2em" width="auto"/>
                </div>
            </div>
            <div class="vertical-line position-absolute"></div>
        </div>
        <div class="col-8 pl-0">
            <div class="details">
                <div class="card mt-2">
                    <div class="card-body">
                        <h2 class="fw-normal" v-html="html"></h2>
                        <span>{{ distance }}</span>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>
<script>

export default {
    name: 'direction-item',
    props: ['html', 'distance', 'icon'],
}
</script>
